import React from 'react';
import {I18n} from 'react-redux-i18n';
import SwitchField from './../../../shared/components/fields/switchField/SwitchField';
import SeriesSubConfigField from './SeriesSubConfigField';

const ChartSeriesConfigField =
    ({
         interfaceCategoryList = [],
         entityList = [],
         unitList = [],
         terminalsListByEntityId = {},
         interfacesListByEntityId = {},
         interfacesListByTerminalId = {},

         mergeYAxis = false,
         forceZero = false,
         series = [],

         /*Handlers*/
         handleMergeYAxisChange,
         handleForceZeroChange,

         ...seriesHandlers
     }) => {
        return (
            <div className="chart-series-form-field">
                <div className="row">
                    <div className="merge-and-force-zero-fields">
                        <SwitchField
                            checked={mergeYAxis}
                            label={I18n.t('dashboard.widgets.formsFields.chartSeries.labels.mergeYAxis')}
                            handleFieldChange={handleMergeYAxisChange}
                            classes="field"
                            width={2}
                        />
                        <SwitchField
                            checked={forceZero}
                            label={I18n.t('dashboard.widgets.formsFields.chartSeries.labels.forceZero')}
                            handleFieldChange={handleForceZeroChange}
                            classes="field"
                            width={2}
                        />
                    </div>
                </div>
                <SeriesSubConfigField
                    {...seriesHandlers}
                    series={series}

                    terminalsListByEntityId={terminalsListByEntityId}
                    interfacesListByEntityId={interfacesListByEntityId}
                    interfacesListByTerminalId={interfacesListByTerminalId}

                    interfaceCategoryList={interfaceCategoryList}
                    entityList={entityList}
                    unitList={unitList}
                />
            </div>
        );
    }

export default ChartSeriesConfigField;